var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("New "+_vm._s(_vm.type))])]),_c('div',{staticClass:"new-object-page",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }